import styled from 'styled-components'

export const Termos = styled.span`
    button {
        color: #4c83ee;
        text-decoration: underline;
        text-underline-offset: 2px;
        &:hover {
            color: #566583;
        }
    }
`
